<template>
    <div class="">

        <v-expansion-panels v-model="panel">
            <v-expansion-panel
            expand
            v-model="panel">
            <v-expansion-panel-header>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">CREAR / BUSCAR INSPECCIONES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-card>
                    <modal-ayuda></modal-ayuda> 
                </v-card>
                <v-row>
                    <v-col cols="2">
                        <label for="">Fecha:</label>
                        <date-picker @change="cargarInspeccion()" class="ml-2" v-model="inspeccion.fecha" single format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                        
                    </v-col>
                    <v-col cols="2">
                        <label for="">Hora:</label>
                        <date-picker class="ml-2" v-model="inspeccion.hora" type="time" format="HH:mm" valueType="HH:mm"></date-picker>
                    </v-col>
                    <v-col cols="4">
                        <v-autocomplete
                        v-model="inspeccion.encargados"
                        auto-select-first
                        chips
                        deletable-chips
                        dense
                        multiple
                        small-chips
                        :items="encargados"
                        item-text="name"
                        item-value="id"
                        label="Inspeccion Realizada Por"
                        ></v-autocomplete>
                    </v-col>
                    <v-col  cols="2">
                        <v-select
                        v-model="inspeccion.estado_l1"
                        auto-select-first
                        chips
                        dense
                        small-chips
                        :items="estados_lineas"
                        item-text="texto"
                        item-value="valor"
                        label="Estado L1"
                        ></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                        v-model="inspeccion.estado_l2"
                        auto-select-first
                        chips
                        dense
                        small-chips
                        :items="estados_lineas"
                        item-text="texto"
                        item-value="valor"
                        label="Estado L2"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <v-select
                        v-model="inspeccion.jefe_turno_id"
                        auto-select-first
                        chips
                        dense
                        small-chips
                        :items="jefes_de_turno"
                        item-text="name"
                        item-value="id"
                        label="Jefe de Turno"
                        ></v-select>
                    </v-col>
                    <v-col cols="3">
                        <v-select
                        v-model="inspeccion.coordinador_patio_id"
                        auto-select-first
                        chips
                        dense
                        small-chips
                        :items="operarios_patio"
                        item-text="name"
                        item-value="id"
                        label="Coordinador de Patio"
                        ></v-select>
                    </v-col>
                    <v-col cols="6">
                        <label for="">Observaciones:</label>
                        <v-text-field v-model="inspeccion.observaciones" type="text"  dense></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-right">
                        <v-btn
                        dark
                        small
                        color="green darken-1"
                        @click="crearInspeccion"
                        v-if="inspeccion.id == null"
                        >
                        <v-icon>
                            add
                        </v-icon>
                        Crear
                        </v-btn>

                        <v-btn
                        dark
                        small
                        color="blue darken-1"
                        @click="actualizarInspeccion"
                        v-if="inspeccion.id != null"
                        >
                        <v-icon>
                            update
                        </v-icon>
                        Actualizar
                        </v-btn>

                        <v-btn
                        dark
                        small
                        color="green darken-1 ml-2"
                        @click="finalizarInspeccion"
                        v-if="inspeccion.id != null"
                        >
                        <v-icon>
                            finish
                        </v-icon>
                        Finalizar
                        </v-btn>

                    </v-col>
                </v-row>
                <!-- <pre>{{inspeccion}}</pre> -->
            </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <!-- sectores -->
        <v-tabs
            v-show="inspeccion.id != null"
            background-color="#004D40"
            center-active
            dark
        >
            <v-tab v-for="(sector,index) in sectores" :key="index" @click="seleccionar_sector(sector,index)">{{sector.nombre}}</v-tab>
        </v-tabs>
        <!-- sectores -->

        <v-card v-if="inspeccion.id != null">
            <table fixed-header height="700px">
                <thead class="teal lighten-2">
                    <tr width="100%">
                        <th class="text-left" rowspan="2" style="width:35% !important;">
                            <v-row>
                                <v-col>
                                    <v-text-field class="ml-3"
                                    v-model="nuevo_item"
                                        label="Item"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-btn dark color="blue darken-1 ml-3" small @click="nuevo_item_sector">
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </th>
                        <th class="text-left" style="width:10% !important;">
                            C/NC
                        </th>                       
                        <th class="text-left" style="width:15% !important;">
                            Area Responsable
                        </th>
                        <th class="text-left" style="width:20% !important;">
                            Causa 
                        </th>
                        
                        <th class="text-left" style="width:20% !important;">
                            Subir Archivo
                        </th>
                    </tr>
                    <tr>
                        <th colspan="3" class="text-left">Detalle / Observaciones</th>
                        <th class="text-center">
                            Opciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr width="100%" v-for="(item,index) in sector_actual.items" :key="index">
                        <td colspan="8">
                            <table  style="table-layout: fixed; width: 100%;">
                                <colgroup>
                                    <col style="width: 35%;">
                                    <col style="width: 10%;">
                                    <col style="width: 15%;">
                                    <col style="width: 20%;">
                                    <col style="width: 20%;">
                                </colgroup>
                                <tr class="teal lighten-4">
                                    <td rowspan="2" class="teal lighten-4 border-bottom text-left" style="width:35% !important">{{ item.orden + ".- " + item.nombre }}</td>
                                    <td class="pt-2">
                                        <v-select
                                        auto-select-first
                                        chips
                                        dense
                                        small-chips
                                        :items="conformidades"
                                        item-text="texto"
                                        item-value="valor"
                                        label="C/NC"
                                        v-model="item.registro.conforme"
                                        ></v-select>
                                    </td>
                                    <td class="pt-2">
                                        <v-autocomplete
                                            auto-select-first
                                            chips
                                            deletable-chips
                                            dense
                                            multiple
                                            small-chips
                                            :items="areas_responsables"
                                            item-text="nombre"
                                            item-value="id"
                                            label="Area"
                                            v-model="item.registro.areas_responsables_ids"
                                        ></v-autocomplete>
                                    </td>
                                    <td class="pt-2">
                                        <v-autocomplete
                                            auto-select-first
                                            chips
                                            deletable-chips
                                            dense
                                            multiple
                                            small-chips
                                            :items="causas"
                                            item-text="causa"
                                            item-value="id"
                                            label="Causa"
                                            v-model="item.registro.causas_ids"
                                        ></v-autocomplete>
                                    </td>
                                    
                                    <td style="width:20% !important; text-align:center;" class="pt-2">
                                        <input type="file" ref="fileupload" @change="uploadFile($event,item)" placeholder="Foto" multiple v-show="item.registro.id" accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx">
                                    </td>
                                </tr>
                                <tr class="teal lighten-4">
                                    <td colspan="3">
                                        <v-text-field
                                            label="Detalle / Observación"
                                            v-model="item.registro.detalle_observacion"
                                            placeholder="Detalle / Observación"
                                        ></v-text-field>
                                        <!-- <video width="320" height="240" controls>
                                            <source src="http://produccionplp.local/archivos/inspecciones/imagenes/1612814457.mp4" type="video/mp4">
                                        </video> -->
                                    </td>
                                    <td style="text-align:center;" class="pt-2">
                                        <v-btn
                                            dark
                                            small
                                            icon
                                            color="green darken-1"
                                            title="Guardar"
                                            @click="guardarRegistroItem(item,index)"
                                        >
                                        <v-icon>
                                            save
                                        </v-icon>
                                        </v-btn>
                                        &nbsp; | &nbsp;
                                        <v-btn
                                            dark
                                            small
                                            icon
                                            color="blue darken-1"
                                            title="Comentarios" 
                                            @click="cargar_archivos_comentarios(item.registro.id)"
                                        >
                                        <v-icon>
                                            comment
                                        </v-icon>
                                        </v-btn>
                                        &nbsp; | &nbsp;
                                        <v-btn v-if="item.registro.tiene_archivos"
                                            class="mx-2"
                                            small
                                            dark
                                            color="purple"
                                            title="Imagen(es)"
                                            icon
                                            @click="cargarArchivos(item,index)"
                                        >
                                            <v-icon dark>
                                                collections
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </v-card>
        
        <!-- <pre>{{sectores[0]}}</pre> -->

        <!-- modal comentarios -->
    <v-dialog
        v-model="dialog"
        hide-overlay
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Comentarios / Archivos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                icon
                dark
                @click="dialog = false"
            >
                <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        
        <v-row class="ml-1 mr-1">
            <v-col v-for="(item,index) in archivos_registro" :key="index">
                <video width="320" height="180" v-if="item.extension == 'mp4'" :src="`${base_url.replace('api/','')}archivos/inspecciones/imagenes/${item.nombre}`" controls></video>
                <img width="320" height="180" v-if="checkear_imagen(item.extension)" style="cursor:pointer;" @click="ver_imagen(item.nombre)" :src="`${base_url.replace('api/','')}archivos/inspecciones/imagenes/${item.nombre}`" alt="">
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-expansion-panels>
            <v-expansion-panel>
            <v-expansion-panel-header expand-icon="add">
                Agregar Comentario
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-alert
                    outlined
                    dense
                    type="info"
                    prominent
                    border="left"
                >
                Debe escribir un comentario y adjuntar al menos 1 archivo (imagen,video,excel, etc. Tamaño Máximo 5Mb)
                </v-alert>
                <v-row>
                    <v-col cols="8">
                         <v-textarea
                            filled
                            name="input-7-4"
                            label="..."
                            v-model="observacion"
                            ></v-textarea>
                        <!-- <input type="file" ref="fileuploadcomment" @change="setear_archivos_comentario($event)" multiple accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"> -->

                    </v-col>
                    <v-col cols="4">
                        <v-file-input
                            counter
                            hide-input
                            multiple
                            show-size
                            truncate-length="5"
                            ref="input_archivo"
                            @change="setear_archivos_comentario($event)" 
                            accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                        ></v-file-input>
                    </v-col>
                </v-row>
                <v-row>
                    <v-btn dark color="green darken-2" @click="agregar_comentario()"><v-icon>comment</v-icon> Comentar</v-btn>
                </v-row>
            </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="ma-1" v-for="(item,index) in comentarios" :key="index">
            <v-card-title>{{item.usuario.name}}</v-card-title>
            <v-card-text>
            <v-row
                align="center"
                class="mx-0"
            >

                <div class="grey--text ml-4">
                {{item.created_at}}
                </div>
            </v-row>

           <!--  <div class="my-4 subtitle-1">
                $ • Italian, Cafe
            </div> -->

            <div>{{item.comentario}}</div>
            </v-card-text>
        </v-card>

      </v-card>
    </v-dialog>

    <!-- Visualizador de Archivos -->
    <v-dialog
      v-model="dialog_archivos"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog_archivos = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
          
        </v-toolbar>
        
        <v-divider></v-divider>
        <v-list
          three-line
          subheader
        >
          <v-subheader>Archivos Subidos</v-subheader>
          <v-subheader>
              <v-row>
              <v-col>
                  <v-btn dark icon color="red darken-1" @click="eliminarImagenes()"><v-icon>delete</v-icon></v-btn> Eliminar Seleccionados
              </v-col>
          </v-row>
          </v-subheader>
          <v-row>
              <v-col v-for="a in archivos_item" :key="a.id">
                <v-list-item>
                    <v-list-item-action>
                    <v-checkbox v-model="a.eliminar"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                    <v-img
                        style="cursor:pointer;"
                        max-height="150"
                        max-width="250"
                        :src="a.url"
                        @click="abrirImagen(a.url)"
                        ></v-img>
                    </v-list-item-content>
                </v-list-item>
              </v-col>
          </v-row>
          
        </v-list>

        <!-- <pre>{{archivos_item}}</pre> -->
      </v-card>
    </v-dialog>

    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        sectores:[],
        areas_responsables:[],
        causas:[],
        encargados:[],
        jefes_de_turno:[],
        operarios_patio:[],
        estados_lineas:[],
        sector_actual:{},
        index_sector:null,
        inspeccion:{
            id:null,
            fecha:null,
            hora:null,
            estado_inspeccion:null,
            estado_l1:null,
            estado_l2:null,
            jefe_turno_id:null,
            coordinador_patio_id:null,
            observaciones:null,
            encargados:[],
            pac_registros_items:[]
        },
        conformidades:[
            {texto:'C',valor:1},
            {texto:'NC',valor:0}
        ],
        panel: 0,
        archivos:null,
        comentarios:[],
        archivos_registro:[],
        dialog:false,
        observacion:'',
        archivos_comentario:{},
        pac_registro_inspecciones_id:null,
        formData: null,
        pac_registros_items:[],
        nuevo_item:'',
        dialog_archivos:false,
        archivos_item:[]
    }),
    mounted() {
        this.cargarDatos();
        this.formData = new FormData();
    },
    methods: {
        abrirAyudas(e){
            e.stopPropagation();
            const jiji = [
                {   titulo:`Ayuda de Crear / Buscar Inspecciones`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se registran o buscan Inspecciones PAC.`},
                {   tipo:`label`,   texto:`- Para buscar una inspección, se especifica una fecha y se rellenarán los campos en caso de que hubiera alguna en esa fecha señalada.`},
                {   tipo:`label`,   texto:`- Para añadir una nueva inspección, se rellenan los campos requeridos: Fecha, Hora, Inspección Realizada Por, Estado L1, Estado L2, Jefe de Turno, Coordinador de Patio y, opcionalmente, Observaciones. Luego se pulsa en el botón "Crear"`},
                {   tipo:`label`,   texto:`- Esto abrirá una tabla con cada uno de los sectores y patios relacionados a la inspección. Se debe indicar cada uno de los detalles, problemas, imágenes y demás datos necesarios por cada ítem de cada sector`},
                {   tipo:`label`,   texto:`- Al finalizar de modificar una inspección, se debe pulsar en el botón "Actualizar". Al finalizar de especificar todo y en caso de poder generarse un informe, se debe pulsar en el botón "Finalizar"`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarDatos(){
            await this.axios.get(`${this.base_url}cargar_inspeccion`,this.headers).then((res)=>{
                this.sectores = res.data.sectores;
                this.areas_responsables = res.data.areas_responsables;
                this.causas = res.data.causas;
                this.encargados = res.data.usuarios;
                this.jefes_de_turno = res.data.jefes_de_turno;
                this.operarios_patio = res.data.operarios_patio;
                this.estados_lineas = res.data.estados_lineas;
                this.sector_actual = this.sectores[0];
                this.index_sector = 0;
                this.iniciarRegistrosSectores();
            }).catch((e)=>{
                console.log('Error:',e);
            })
        },

        async cargarInspeccion(){
            this.mostrarLoading({titulo:'Buscando inspección...',color:'green'})
            let url = `${this.base_url}pac_inspeccion/fecha/${this.inspeccion.fecha}`;
            this.limpiar();
            /* await this.axios.get(url,this.headers).then((res)=>{

            }).catch((e)=>{
                console.log('Error:',e);
            }); */
            await this.axios.get(url,this.headers).then((res)=>{
                console.log(res.data.pac_inspeccion);
                //let pac_inspeccion = res.pac_inspeccion;
                //this.$set(this.inspeccion, 'id', res.data.pac_inspeccion.id)
                if(res.data.pac_inspeccion){
                    this.inspeccion.id = res.data.pac_inspeccion.id;
                    this.inspeccion.fecha = res.data.pac_inspeccion.fecha;
                    this.inspeccion.hora = res.data.pac_inspeccion.hora;
                    this.inspeccion.estado_inspeccion = res.data.pac_inspeccion.estado_inspeccion;
                    this.inspeccion.estado_l1 = res.data.pac_inspeccion.estado_l1;
                    this.inspeccion.estado_l2 = res.data.pac_inspeccion.estado_l2;
                    this.inspeccion.jefe_turno_id = res.data.pac_inspeccion.jefe_turno_id;
                    this.inspeccion.coordinador_patio_id = res.data.pac_inspeccion.coordinador_patio_id;
                    this.inspeccion.encargados = res.data.pac_inspeccion.encargados_ids;
                    this.inspeccion.pac_registros_items = res.data.pac_inspeccion.pac_registros_items;
                    this.inspeccion.observaciones = res.data.pac_inspeccion.observaciones;
                    this.pac_registros_items = res.data.pac_inspeccion.pac_registros_items;
                }
                this.iniciarRegistrosSectores();
                this.ocultarLoading();

            }).catch((e)=>{
                console.log('Error:',e);
                this.errorMessage(e, "Error al buscar Inspección ");
            })
        },

        async crearInspeccion(){
            let url = `${this.base_url}pac_inspeccion`;
            let body = this.inspeccion;
            /* await this.axios.get(url,this.headers).then((res)=>{

            }).catch((e)=>{
                console.log('Error:',e);
            }); */
            await this.axios.post(url,body,this.headers).then((res)=>{
                this.inspeccion = res.data.data;
                //this.inspeccion.id = res.data.data.id;
                this.pac_registros_items = res.data.data.pac_registros_items;
                console.log('inspeccion',this.inspeccion);
                this.iniciarRegistrosSectores();
            }).catch((e)=>{
                console.log('Error:',e);
            })
        },

        async actualizarInspeccion(){
            let url = `${this.base_url}pac_inspeccion/${this.inspeccion.id}`;
            let body = this.inspeccion;
            /* await this.axios.get(url,this.headers).then((res)=>{

            }).catch((e)=>{
                console.log('Error:',e);
            }); */
            await this.axios.put(url,body,this.headers).then((res)=>{
                
            }).catch((e)=>{
                console.log('Error:',e);
            })
        },

        async guardarRegistroItem(item,index){
            let url = `${this.base_url}pac_registro_inspeccion`;
            let body = item.registro;
            /* await this.axios.get(url,this.headers).then((res)=>{

            }).catch((e)=>{
                console.log('Error:',e);
            }); */
            body.pac_inspecciones_id = this.inspeccion.id;
            console.log('bodicito',body);
            if(item.registro.id == null){
                //crear
                await this.axios.post(url,body,this.headers).then((res)=>{
                    console.log(res.data.data.id);
                    this.$set(this.sectores[this.index_sector].items[index].registro,'id',res.data.data.id);
                    //this.iniciarRegistrosSectores();
                }).catch((e)=>{
                    console.log('Error:',e);
                });
            }else{
                //actualizar
                url = `${this.base_url}pac_registro_inspeccion/${item.registro.id}`;
                await this.axios.put(url,body,this.headers).then((res)=>{
                    //console.log(res.data.data.id);
                    //this.$set(this.sectores[this.index_sector].items[index].registro,'id',res.data.data.id);
                    //this.iniciarRegistrosSectores();
                }).catch((e)=>{
                    console.log('Error:',e);
                });
            }
            
        },

        async cargar_archivos_comentarios(id){
            console.log(id);
            this.pac_registro_inspecciones_id = id;
            await this.axios.get(`${this.base_url}cargar_archivos_comentarios/${id}`,this.headers).then((res)=>{
                this.comentarios = res.data.comentarios;
                this.archivos_registro = res.data.archivos;
                this.dialog = true;
                this.observacion = '';
                this.$refs.input_archivo.value=null;
            }).catch((e)=>{
                console.log('Error:',e);
            });
        },

        iniciarRegistrosSectores(){
            this.sectores.forEach((sector,index) => {
                sector.items.forEach((item,idx) => {

                    //let registro = this.inspeccion.pac_registros_items.find(i => i.pac_items_sectores_id == item.id);
                    let registro = this.pac_registros_items.find(i => i.pac_items_sectores_id == item.id);
                    if(registro){
                        this.$set(this.sectores[index].items[idx], 'registro',registro);
                    }else{
                        this.$set(this.sectores[index].items[idx], 'registro', {
                            id:null,
                            conforme:null,
                            detalle_observacion:null,
                            estado_item:null,
                            pac_items_sectores_id:item.id,
                            pac_inspecciones_id:this.inspeccion.id,
                            areas_responsables_ids:[],
                            causas_ids:[]
                        })
                    }
                    
                });
            });
        },

        seleccionar_sector(sector,index){
            this.sector_actual = sector;
            this.index_sector = index;
        },

        limpiar(){
            this.inspeccion.id = null;
            //this.inspeccion.fecha = null;
            this.inspeccion.hora = null;
            this.inspeccion.estado_inspeccion = null;
            this.inspeccion.estado_l1 = null;
            this.inspeccion.estado_l2 = null;
            this.inspeccion.jefe_turno_id = null;
            this.inspeccion.coordinador_patio_id = null;
            this.inspeccion.observaciones = null;
            this.inspeccion.encargados = [];
            this.inspeccion.pac_registros_items = [];

            this.sectores.forEach((sector,index) => {
                sector.items.forEach((item,idx) => {
                    
                    this.$set(this.sectores[index].items[idx], 'registro', {
                        id:null,
                        conforme:null,
                        detalle_observacion:null,
                        estado_item:null,
                        pac_items_sectores_id:item.id,
                        pac_inspecciones_id:this.inspeccion.id,
                        areas_responsables_ids:[],
                        causas_ids:[]
                    })
                });
            });
        },

        setear_archivos_comentario(files){
            files.forEach(f => {
                this.formData.append('files[]', f);
            });
        },

        async agregar_comentario(){
            this.formData.append('pac_registro_inspecciones_id',this.pac_registro_inspecciones_id);
            this.formData.append('comentario',this.observacion);
            await this.axios.post(`${this.base_url}agregar_comentario_archivos`, this.formData, this.headers).then((res) => {
                if(res.status == 200){
                    this.formData.files = null;
                    this.dialog = false;
                }
            }).catch((e)=>{
                console.log('ERROR:',e);
            });
            
        },

        uploadFile (event,item) {
            console.log('evento',event.target.files,'item',item);
            this.archivos = event.target.files;
            let archivos = [];
            const formData = new FormData();
            for (const i of Object.keys(this.archivos)) {
                formData.append('files[]', this.archivos[i])
                //archivos.push(this.archivos[i]);
            }
            formData.append('pac_registro_inspecciones_id',item.registro.id);
            this.axios.post(`${this.base_url}subir_archivos`, formData, this.headers).then((res) => {
                console.log(res);
                this.$refs.fileupload.value=null;
            }).catch((e)=>{
                console.log('ERROR:',e);
            })
        },
        handleSubmit() {
          const formData = new FormData();
          for (const i of Object.keys(this.files)) {
            formData.append('files', this.files[i])
          }
          axios.post('http://localhost:4000/api/file-upload', formData, {
          }).then((res) => {
            console.log(res)
          })
        },

        ver_imagen(nombre_archivo){
            //window.location.href = `${this.base_url.replace('api/','')}archivos/inspeccion_pac/${nombre_archivo}`;
            window.open(`${this.base_url.replace('api/','')}archivos/inspecciones/imagenes/${nombre_archivo}`, '_blank');
        },

        checkear_imagen(extension){
            let extensiones = ['jpg','jpeg','png'];
            let esta = extensiones.find(e => e == extension);
            return esta?true:false;
        },

        async nuevo_item_sector(){
            let body = {
                nombre:this.nuevo_item,
                pac_sectores_inspecciones_id:this.sector_actual.id
            }

            await this.axios.post(`${this.base_url}pac_item_sector`,body,this.headers).then((res)=>{
                this.sectores[this.index_sector].items.push(res.data.data);
                this.nuevo_item = '';
                this.iniciarRegistrosSectores();
            }).catch((e)=>{
                console.log('error',e);
            })
        },

        async finalizarInspeccion(){
            await this.axios.get(`${this.base_url}generar_informe_pac/${this.inspeccion.id}`,this.headers).then((res)=>{
                console.log('informe generado',res.data);
            }).catch((e)=>{
                console.log('error',e);
            });
        },

        async cargarArchivos(item,index){
            await this.axios.get(`${this.base_url}pac_registro_inspeccion/${item.registro.id}/cargar_archivos`,this.headers).then((res)=>{
                this.archivos_item = res.data.data;
            }).catch((e)=>{
                console.log(e);
            });
            this.dialog_archivos = true;
        },

        abrirImagen(url){
            window.open(url);
        },

        async eliminarImagenes(){
            let ids = [];
            this.archivos_item.forEach(a => {
                if(a.eliminar){
                    ids.push(a.id);
                }
            });

            await this.axios.post(`${this.base_url}eliminar_archivos_pac_inspeccion`,{ids:ids},this.headers).then((res)=>{
                console.log('Eliminados',res.data.data);
            }).catch((e)=>{
                console.log(e);
            });

            this.archivos_item.forEach((a,idx)=>{
                if(a.eliminar){
                    this.archivos_item.splice(idx,1);
                }
            });
            console.log(ids);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
.v-tab--active {
    color: inherit;
    background-color: #00838F !important;
}
</style>